<template>
  <v-app>
    <v-main>
      <!-- <Navbar /> -->
      <div>
        <router-view name="navbar"></router-view>
      </div>
      <div>
        <router-view></router-view>
      </div>
    </v-main>
  </v-app>
</template>

<script>
// import { useCookies } from "vue3-cookies";
import VueCookies from "vue-cookies";
import store from "./store";
import AuthLogin from "./views/AuthLogin.vue";
import Navbar from "./components/AppBar.vue";
// import {       } from "vue-cookie-next";
// import { watchEffect } from "vue";
import { inject } from "vue";

export default {
  name: "App",
  component: {
    AuthLogin,
    Navbar,
  },
  data: () => ({
    showDialog: false,
    msg: "",
    isAuth: false,
    urlparam: [],
    utility: inject("utils"),
    userId: null,
  }),
  beforeMount() {
    // VueCookies.set(
    //   "lastVisitedUrl",
    //   location.origin + this.$router.currentRoute.value.fullPath,
    //   null,
    //   nu
    //   ".competiscan.com"
    // );
    // //  integrate v2 with unified login
    // working code
    // alert("before mount");
    // console.log(window.location.href, "path");

    let pathToBypass = ["/productdetail", "/pdfcontentdetail"];
    console.log(">>>>", pathToBypass);
    if (!(pathToBypass.indexOf(window.location.pathname) > -1)) {
      console.log(">>>>>>SFAS");
      const access_tokenookie = VueCookies.get("access_token");
      if (access_tokenookie) {
        this.$router.replace("/power_search");
      } else {
        VueCookies.set("lastVisitedUrl", window.location.href, {
          domain: ".competiscan.com",
        });
        // only domain.com are readable
        window.location.href = "https://auth.pre-prod.competiscan.com/";
      }
    }
    //end working code
    // breakme: {
    // const lastVisitedCookie = VueCookies.get("lastVisitedUrl");
    // console.log(location.origin, 77);
    // setCookie("lastVisitedUrl", location.origin, 30, ".cp.dev.competiscan");
    // if (VueCookies.get("access_token")) {
    // alert("token exist");
    //  this.$router.replace("/"); // Proceed to the route
    //} else {
    // setCookie("lastVisitedUrl", location.origin, 30, ".cp.dev.competiscan");
    // alert("token does not exist");
    //VueCookies.set(
    //"lastVisitedUrl",
    //   location.origin,
    //   null,
    //   null,
    //   ".competiscan.com"
    // );
    // setTimeout(() => {
    //location.href = "https://auth.dev.competiscan.com/";
    // }, 5000);
    // next("https://dev01-admin.competiscan.com/"); // Redirect to a different route if needed
    //}
    // function setCookie(cookieName, cookieValue, expirationDays, domain) {
    //   const date = new Date();
    //   date.setTime(date.getTime() + expirationDays * 24 * 60 * 60 * 1000);
    //   const expires = "expires=" + date.toUTCString();
    //   const cookieDomain = domain ? `;domain=${domain.slice(7)}` : "";
    //   document.cookie =
    //     cookieName +
    //     "=" +
    //     cookieValue +
    //     ";" +
    //     expires +
    //     ";path=/" +
    //     cookieDomain;
    // }
    // function getCookie(cookieName) {
    //   const name = cookieName + "=";
    //   const decodedCookie = decodeURIComponent(document.cookie);
    //   const cookieArray = decodedCookie.split(";");
    //   for (let i = 0; i < cookieArray.length; i++) {
    //     let cookie = cookieArray[i].trim();
    //     if (cookie.indexOf(name) === 0) {
    //       return cookie.substring(name.length, cookie.length);
    //     }
    //   }
    //   return "";
    // }
    // }
    // VueCookieNext.setCookie("theme", "default");
    // let my_cookie_value = VueCookieNext.getCookie("theme");
    // console.log(my_cookie_value, 88);
    // this.cookies.set("myCoookie", "abcdefg");
  },
  // watch: {
  //   urlparam() {
  //     let uri = window.location.search.substring(1);
  //     let params = new URLSearchParams(uri);
  //     console.log(params.get("var_name"));
  //     this.urlparam = params;
  //     console.log(1212, this.urlparam);
  //   },
  // },

  mounted() {
    // this.dataAsPerRoleAPI();
    // this.userRawData();
    // alert("mounted");
    // if (
    //   this.$utils.isValidToken() === false &&
    //   this.$router.history.current.name !== "signin"
    // ) {
    //   this.$router.push({ name: "signin" });
    // }
    // // if user already logged in one tab and trying to open login app in another tab
    // // then he will be redirected to higher precedence portal or default portal
    // if (this.$utils.isValidToken() === true && this.isPrecedenceUrlPresent()) {
    //   location.href = this.$utils.getCookies("precedence_url");
    // }
  },
  methods: {
    //   isPrecedenceUrlPresent: function () {
    //     let isPresent = false;
    //     let url = this.$utils.getCookies("precedence_url");
    //     if (url != "undefined" && url != null) {
    //       isPresent = true;
    //     }
    //     return isPresent;
    //   },
    // },
    dataAsPerRoleAPI() {
      // Define the URL and the data to be sent
      const url = "https://dev06.competiscan.com:5057/user-permission";
      // Define the options for the fetch request
      const options = {
        method: "GET", // Specify the HTTP method
        headers: {
          "Content-Type": "application/json", // Set the content type to JSON
          "user-id": 3281,
        },
      };
      // Make the fetch request
      fetch(url, options)
        .then((response) => {
          if (!response.ok) {
            // Handle HTTP errors
            throw new Error(
              "Network response was not ok " + response.statusText
            );
          }
          return response.json(); // Parse the JSON response
        })
        .then((data) => {
          // Handle the response data
          console.log("Success:", data);
          store.dispatch("Rawdata/setUpdatedRawDataAction", data);
        })
        .catch((error) => {
          // Handle errors
          console.error("There was a problem with the fetch operation:", error);
        });
    },
    userRawData() {
      // Define the URL and the data to be sent
      const url = "https://users-uat-api.competiscan.com/get-client-rawdata";
      // Define the options for the fetch request
      const options = {
        method: "GET", // Specify the HTTP method
        headers: {
          "Content-Type": "application/json", // Set the content type to JSON
          Authorization: "Bearer YOUR_ACCESS_TOKEN", // Optional: include authorization header if needed
        },
      };
      // Make the fetch request
      fetch(url, options)
        .then((response) => {
          if (!response.ok) {
            // Handle HTTP errors
            throw new Error(
              "Network response was not ok " + response.statusText
            );
          }
          return response.json(); // Parse the JSON response
        })
        .then((data) => {
          // Handle the response data
          console.log("client raw:", data.data);
          store.dispatch("Rawdata/setUserRawDataAction", data.data);
        })
        .catch((error) => {
          // Handle errors
          console.error("There was a problem with the fetch operation:", error);
        });
    },
  },
};
</script>

<style>
* {
  font-size: 12px;
  font-family: "Open Sans", sans-serif;
}
</style>
